export default defineNuxtPlugin({
  name: 'app-bridge-init',
  // The module still requires core plugin dependencies despite modularization efforts.
  // Logger plugin was replaced with namespaced inline instances, but axios and our pinia
  // store are still necessary to retry failed requests using the user token.
  dependsOn: ['init-base-store'],
  parallel: true,
  setup() {
    const $log = logger.createLogMethods('app-bridge:init-plugin');

    if (import.meta.server) {
      $log.debug(`Skipping initialization, is server-side.`);
      return {
        provide: {
          appBridge: createAppBridgeSSRStub(),
        },
      };
    }

    if (!useMainStore().isAppview) {
      $log.debug(`Skipping initialization, is not appview.`);
      return {
        provide: {
          appBridge: createAppBridgeSSRStub(),
        },
      };
    }

    $log.debug(`Initializing...`);

    // Initialize bridge separately before interceptor plugin.
    // Prevents await deadlock when calling bridge actions before the helper was provided.
    const appBridge = createAppBridge();

    // Provide global window helper, this is should be used by native app and our Tempermonkey mocks
    window.$appBridge = appBridge;

    // Provide global nuxt helper, this should be used by our own code
    return {
      provide: {
        appBridge,
      },
    };
  },
});
